/**
 * StatsSection - Chips de estatísticas (Status e Prioridade)
 */
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

const StatsSection = ({
    stats,
    statusFilter,
    setStatusFilter,

}) => {
    const total = stats.statusStats?.reduce((sum, s) => sum + s.count, 0) || 0;
    const pending = stats.statusStats?.find(s => s._id === 'pending')?.count || 0;
    const processing = stats.statusStats?.find(s => s._id === 'processing')?.count || 0;
    const completed = stats.statusStats?.find(s => s._id === 'completed')?.count || 0;



    return (
        <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
            {/* Por Status */}
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>Status:</Typography>
                <Chip label={`Total: ${total.toLocaleString('pt-BR')}`} size="small" variant="outlined" />
                <Chip
                    label={`Pendente: ${pending.toLocaleString('pt-BR')}`}
                    size="small"
                    color="warning"
                    variant={statusFilter === 'pending' ? 'filled' : 'outlined'}
                    onClick={() => setStatusFilter('pending')}
                    sx={{ cursor: 'pointer' }}
                />
                <Chip
                    label={`Processando: ${processing.toLocaleString('pt-BR')}`}
                    size="small"
                    color="info"
                    variant={statusFilter === 'processing' ? 'filled' : 'outlined'}
                    onClick={() => setStatusFilter('processing')}
                    sx={{ cursor: 'pointer' }}
                />
                <Chip
                    label={`Concluído: ${completed.toLocaleString('pt-BR')}`}
                    size="small"
                    color="success"
                    variant={statusFilter === 'completed' ? 'filled' : 'outlined'}
                    onClick={() => setStatusFilter('completed')}
                    sx={{ cursor: 'pointer' }}
                />
            </Box>

            {/* Por Prioridade (Removido para simplificar) */}
        </Box>
    );
};

export default StatsSection;
